import React from "react";
import { QuoteTableSectionInfoCollective } from "../../../../types/quoteTable/QuoteTableSectionInfo";
import QuoteTableSection from "../QuoteTableSection";
import cx from "classnames";
import { QuoteTableInfo } from "../../../../types/quoteTable/QuoteTableInfo";
import Accordion from "../../../../../common/components/Accordion/Accordion";

interface IQuoteTablePanel {
    panel: QuoteTableSectionInfoCollective;
    size: QuoteTableInfo["size"];
    isFirstSection: boolean;
    isLastSection: boolean;
    isAccordion: boolean;
    endCardContent?: QuoteTableInfo["endCardContent"];
}

const QuoteTablePanel: React.FC<IQuoteTablePanel> = (props) => {
    const {
        panel,
        size,
        isFirstSection,
        isLastSection,
        isAccordion,
        endCardContent
    } = props;

    return (
        <div className={cx("gap-pre-xl", "layout-fit-content")}>
            <Accordion
                headerClassName={cx(
                    "panel-tea-green",
                    "panel-quote-product-header",
                    "layout-quote-table-section-header"
                )}
                headerContent={
                    <span
                        className={cx(
                            "text-font-size-l",
                            "text-primary",
                            "text-semi-bold"
                        )}>
                        {panel.title}
                    </span>
                }
                setArrowAlignment={"left"}
                arrowIconDirection={"left"}
                isOpenByDefault
                isAlwaysOpen={!isAccordion}>
                {panel.sections.map(
                    (section, index) =>
                        section && (
                            <QuoteTableSection
                                key={section.id}
                                sectionId={section.id}
                                title={section.title}
                                learnMoreHandler={section.learnMoreHandler}
                                tooltip={section.tooltip}
                                cells={section.cells}
                                isFirstSection={isFirstSection && index === 0}
                                isLastSection={
                                    isLastSection && index + 1 === panel.sections.length
                                }
                                size={size}
                                cellComponent={section.component}
                                renderOnError={section.renderOnError}
                                endCardContent={endCardContent}
                            />
                        )
                )}
            </Accordion>
        </div>
    );
};

export default QuoteTablePanel;
